if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
// Get from cart.js returns the cart in JSON
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
      return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
          callback(cart,textStatus, xhr);
        }
        else {
          Shopify.onCartUpdate(cart);
        }
      });
    }else{
      if ((typeof callback) === 'function') {
        callback(cart);
      }else if(typeof Shopify.onCartUpdate ==='function') {
        Shopify.onCartUpdate(cart);
      }
    }
  };
}
function updateMiniCart()
{
  $.ajax({
    type: "GET",
    url: "/",
    dataType: 'html',
    success: function(data) 
    {
      var miniCartData=$(data).find('.cart-popup__wrapper').html();
      $('.cdesk-cart-popup .cart-popup__wrapper').html(miniCartData);
    }
  })
}

function updateProduct(quantity,lineNo)
{
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=' + quantity + '&line=' + lineNo,
    dataType: 'json',
    success: function(data){
      Shopify.getCart(function(cart) {
        updateMiniCart();
      });  
    }
  })
}

function ajaxAddToCart(currentThis,dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){
      console.log('[cdesk] /cart/add success', { data: data });
      Shopify.getCart(function(cart) {
        currentThis.removeClass('untouchable');
        if($('body').hasClass('template-product')){
          var v_pprice = $('.product-form__item option:selected').attr('data-price');
          if(!v_pprice || v_pprice === 'undefined'){
            var saleEl = $('[data-sale-price]');
            var regEl = $('[data-regular-price]');
            if(saleEl.length && $.trim(saleEl.text()).length){
              v_pprice = $.trim(saleEl.text());
            } else if(regEl.length && $.trim(regEl.text()).length){
              v_pprice = $.trim(regEl.text());
            }
          }
          if(!v_pprice || v_pprice === 'undefined'){
            currentThis.text('Add To Cart');
          } else {
            currentThis.text('Add To Cart - ' + v_pprice);
          }
        }
        updateMiniCart();
        $('.cdesk-cart-popup .cart-popup__wrapper').addClass('slideOpen');
        $('.cdesk-cart-popup .cart-popup-overlay').fadeIn();
        $('html').addClass('slider_open_right');
      });   
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error('[cdesk] /cart/add error', {
        status: jqXHR && jqXHR.status,
        responseJSON: jqXHR && jqXHR.responseJSON,
        responseText: jqXHR && jqXHR.responseText,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
      currentThis.removeClass('untouchable');
      currentThis.text('Add to cart');

      var message = '';
      var resp = jqXHR && jqXHR.responseJSON ? jqXHR.responseJSON : null;

      if (resp && typeof resp === 'object') {
        if (resp.description) {
          message = resp.description;
        } else if (resp.message) {
          message = resp.message;
        }
      }

      if (!message && jqXHR && typeof jqXHR.responseText === 'string' && jqXHR.responseText.length) {
        try {
          var parsed = JSON.parse(jqXHR.responseText);
          if (parsed && typeof parsed === 'object') {
            message = parsed.description || parsed.message || '';
          }
        } catch(e){}
      }

      if (!message) {
        if (jqXHR && jqXHR.status == 422) {
          message = 'This product cannot be added to your cart. It may be sold out or unavailable.';
        } else if (jqXHR && jqXHR.status == 400) {
          message = 'There was a problem adding this item to your cart. Please check your options and try again.';
        } else {
          message = 'There was a problem adding this item to your cart. Please try again.';
        }
      }

      alert(message);
    }
  });
}
$(document).ready(function(){
  

  $('body').on('click', '.add-to-cart', function(){
    var Items = [];
    var currentThis = $(this);
    currentThis.addClass('untouchable');
    var rawDataValue = $(this).attr('data-value');
    var variantID = $.trim((rawDataValue || ''));

    console.log('[cdesk] .add-to-cart click', {
      element: this,
      rawDataValue: rawDataValue,
      resolvedVariantID: variantID
    });

    if(!variantID || variantID === 'undefined' || variantID === 'null'){
      currentThis.removeClass('untouchable');
      currentThis.text('Add To Cart');
      console.warn('[cdesk] Invalid data-value on .add-to-cart; blocking addToCart');
      alert('Please select a valid option before adding this item to your cart.');
      return;
    }

    Items.push({ "id": variantID, "quantity": 1 }); 
    console.log('[cdesk] sending /cart/add from .add-to-cart', Items);
    ajaxAddToCart(currentThis,Items);

  })

  $('body').on('click', '#cart_wrapper_content .cart__remove', function(){
    var currentThis = $(this);  var quantity = 0;
    var lineNo = $.trim( $(this).attr('data-line') ); 
    updateProduct(quantity,lineNo);
  })

  $('body').on('click', '.cart__update-controls .qty-button-plus', function(){
    var currentThis = $(this);  
    var qty =  parseInt( $(this).siblings('.cart__qty-input').val() ); var lineNo = $.trim( $(this).attr('data-line') ); 
    if(qty >= 1){ qty = qty +1 } else { qty = 1; }
    updateProduct(qty,lineNo);
  })
  $('body').on('click', '.cart__update-controls .qty-button-minus', function(){
    var currentThis = $(this); 
    var qty =  parseInt( $(this).siblings('.cart__qty-input').val() ); var lineNo = $.trim( $(this).attr('data-line') ); 
    if(qty >= 1){ qty = qty - 1 } else { qty = 0; }
    updateProduct(qty,lineNo);
  })

  $('body').on('change', '.cart__update-controls .cart__qty-input', function(){
    var currentThis = $(this); 
    var qty =  parseInt( $('.cart__qty-input').val() ); var lineNo = $.trim( $(this).attr('data-line') ); 
    if(qty < 1){ qty = 0 }
    updateProduct(qty,lineNo);
  })



  $('body').on('click', '.apply_cart_promrocodet', function(e){
    //  if (e.keyCode == 13) {
    var promoCode = $.trim( $('#promo_code_submitter').val() );
    console.log('promoCode :: '+promoCode);
    if(promoCode == ''){
      alert('Please enter promo code');
    }
    else
    {
      localStorage.setItem("promoCode", promoCode);
      $('.messages__for_alert').text('Promo code applied at checkout.');
      $('.apply_cart_promrocodet').addClass('hide').removeClass('show');
      $('.remove_cart__promrocode').addClass('show').removeClass('hide');
    }

    // }
  })

  $('body').on('click', '.remove_cart__promrocode', function(e){
    $('#promo_code_submitter').val('');  localStorage.setItem("promoCode", ''); 
    $('.messages__for_alert').text('your promo code is cleared successfully.')
    $('.apply_cart_promrocodet').addClass('show').removeClass('hide');
    $('.remove_cart__promrocode').addClass('hide').removeClass('show');
  })

  $('body').on('click', '.checkout-btn .cart__submit', function(){
    var promoCode =  localStorage.getItem("promoCode");   console.log('promoCode :: '+promoCode);
    if(promoCode != ''){
      if(promoCode != null){
        window.location.href = '/checkout?discount='+promoCode;
      }else{
        window.location.href = '/checkout';
      }
    } else{
      window.location.href = '/checkout';
    } 
  })
  var promoCode =  localStorage.getItem("promoCode"); $('#promo_code_submitter').val(promoCode);

  if(promoCode != ''){
    if(promoCode != null){
      console.log('promoCode::'+promoCode)
      var cartPageUrl = $('form.cart').attr('action'); cartPageUrl = cartPageUrl+'?discount='+promoCode;  $('form.cart').attr('action',cartPageUrl);
    }
  }

  if(promoCode == ''){ 
    $('.apply_cart_promrocodet').addClass('show').removeClass('hide');
    $('.remove_cart__promrocode').addClass('hide').removeClass('show');
  }
  else
  { 
    $('.apply_cart_promrocodet').addClass('hide').removeClass('open');
    $('.remove_cart__promrocode').addClass('show').removeClass('show');
  }
  $('body').on('click', '#slideOpen .site-nav__label', function(e){
    $('.cart-popup__wrapper').addClass('slideOpen');
    $('.cart-popup-overlay').fadeIn();
    $('html').addClass('slider_open_right');
  }); 
  $('body').on('click', '.cart-popup__close, .cart-popup-overlay', function(e){
    $('.cart-popup__wrapper').removeClass('slideOpen');
    $('.cart-popup-overlay').fadeOut();
    $('html').removeClass('slider_open_right');
  });

  $('body').on('click', '.bundle-card__swatch, .bundle-card__swatch *, .varient__color--list-item, .varient__color--list-item *', function(e){
    var $li = $(e.target).closest('li');
    $li.parents('ul').find('li').removeClass('activatedMe'); var variantTitleName = '';
    var totalOption = $('.bundle-card, .custom-varient').length; var startFrom = 1;
    $li.addClass('activatedMe');
    var colorOptionName = $li.attr('data-option-color');
    var colorOptionImage = $li.attr('data-option-image');
    var $card = $li.closest('.bundle-card');
    if ($card.length) {
      $card.find('.bundle-card__image img').attr('src', colorOptionImage);
    } else {
      $li.parents('.custom-varient').find('.varient__image').find('img').attr('src', colorOptionImage);
    }
    // Build variant title from selections in order of cards/lists
    $('.bundle-card, .custom-varient').each(function(){
      var OptionName = $(this).find('.bundle-card__swatch.activatedMe').attr('data-option-name');
      if(!OptionName){
        OptionName = $(this).find('.varient__color--list-item.activatedMe').attr('data-option-name');
      }
      OptionName = $.trim(OptionName || '');
      if(!OptionName) return; // skip if none
      if(startFrom < totalOption){
        variantTitleName += OptionName + ' + '; startFrom++;
      } else {
        variantTitleName += OptionName; startFrom++;
      }
    });

    // Handleize to match option[data-variantone]
    function handleize(str){
      return $.trim(String(str))
        .toLowerCase()
        .replace(/['"]/g,'')
        .replace(/[^a-z0-9]+/g,'-')
        .replace(/^-+|-+$/g,'');
    }
    variantTitleName = variantTitleName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    var $selector = $('[id^="ProductSelect-"]');

    // --- Strategy 1: match by per-group title + colour (for Scrunchie bundles) ---
    var $exactOption = $();

    // Collect the active colour for each bundle group (e.g. each "Best Scrunchies" row)
    var selectedChunks = [];
    $('.bundle-card, .custom-varient').each(function(){
      var $group = $(this);
      var groupTitle = $.trim($group.find('.title').first().text() || '');
      var colorVal = $group.find('.bundle-card__swatch.activatedMe').attr('data-option-color');
      if (!colorVal) {
        colorVal = $group.find('.varient__color--list-item.activatedMe').attr('data-option-color');
      }
      colorVal = $.trim(colorVal || '');
      if (!groupTitle && !colorVal) return; // skip empty groups
      selectedChunks.push({ title: groupTitle, color: colorVal });
    });

    function normalizeColor(str) {
      return $.trim(String(str)).toLowerCase();
    }

    if (selectedChunks.length) {
      $selector.find('option').each(function(){
        var $opt = $(this);
        var fullTitle = $opt.attr('data-title') || $opt.text();
        var segments = $.map(fullTitle.split('+'), function(seg){ return $.trim(seg); });

        // Require the same number of parts as custom groups
        if (segments.length !== selectedChunks.length) {
          return; // continue each()
        }

        var ok = true;
        for (var i = 0; i < selectedChunks.length; i++) {
          var groupTitle = normalizeColor(selectedChunks[i].title);
          var color = normalizeColor(selectedChunks[i].color);

          // Only enforce colour match on scrunchies-style groups
          if (groupTitle.indexOf('scrunchies') !== -1) {
            var part = normalizeColor(segments[i]);
            if (color && part.indexOf(color) === -1) {
              ok = false;
              break;
            }
          }
        }

        if (ok) {
          $exactOption = $opt;
          return false; // break out of .each
        }
      });
    }

    // --- Strategy 2: fallback to older handle-based logic if no exact title match ---
    if (!$exactOption.length) {
      var hv = handleize(variantTitleName);
      $exactOption = $selector.find('option[data-variantone="'+hv+'"]');

      if (!$exactOption.length) {
        // Build handles list and try color-based match silently (original behaviour)
        var handles = $selector.find('option').map(function(){ return $(this).attr('data-variantone'); }).get();
        var colorText = (
          $('.bundle-card:contains("Best Scrunchies") .bundle-card__swatch.activatedMe').attr('data-option-color') ||
          $('.custom-varient .title:contains("Best Scrunchies")').closest('.custom-varient').find('.varient__color--list-item.activatedMe').attr('data-option-color') ||
          $li.attr('data-option-color') || ''
        ).toString();
        var colorHandle = handleize(colorText);
        var patternMatch = handles.find(function(h){ return typeof h === 'string' && h.indexOf('-'+colorHandle+'-scrunchies') !== -1; });
        if(patternMatch){
          $exactOption = $selector.find('option[data-variantone="'+patternMatch+'"]');
        }
      }
    }

    var v_price = $exactOption.attr('data-price');
    // Fallbacks to avoid showing 'undefined' on the button if mapping fails
    if(!v_price || v_price === 'undefined'){
      // try currently selected option in the hidden select
      v_price = $('.product-form__item option:selected').attr('data-price');
      // if still missing, try visible price elements rendered by the theme
      if(!v_price || v_price === 'undefined'){
        var saleEl = $('[data-sale-price]');
        var regEl = $('[data-regular-price]');
        if(saleEl.length && $.trim(saleEl.text()).length){
          v_price = $.trim(saleEl.text());
        } else if(regEl.length && $.trim(regEl.text()).length){
          v_price = $.trim(regEl.text());
        }
      }
    }
    
    if($('#ProductSelect-product-template option[data-variantone="'+variantTitleName+'"]').prop('disabled')){
      $('.best-product-template .best-product-form .product-form__cart-submit').prop('disabled',true);
      $('.best-product-template .best-product-form .product-form__cart-submit').text('Sold out');
    }else{
      $('.best-product-template .best-product-form .product-form__cart-submit').prop('disabled',false);
      // Ensure we never append undefined to the button label
      if(!v_price || v_price === 'undefined'){
        v_price = '';
        $('.best-product-template .best-product-form .product-form__cart-submit').text('Add To Cart');
      } else {
        $('.best-product-template .best-product-form .product-form__cart-submit').text('Add To Cart - ' + v_price);
      }
    }

    var variantValue = $exactOption.attr('data-value');
    $selector.val(variantValue).change();
  });

  $('.bundle-card__swatches li:first-child, .custom-varient .varient__color .varient__color--list li:first-child').trigger('click');

  $('.product-form__cart-submit.btn--secondary-accent').click(function(){

    var Items = []; var currentThis = $(this); currentThis.addClass('untouchable'); currentThis.text('Please wait ...');
    var variantID = '';

    console.log('[cdesk] .product-form__cart-submit click - start variant detection');

    // Primary: product_selector_target (used on main product template)
    var $primarySelected = $('.product_selector_target option:selected');
    console.log('[cdesk] primarySelected length', $primarySelected.length, $primarySelected.get());
    if ($primarySelected.length) {
      variantID = $.trim($primarySelected.val() || '');
      console.log('[cdesk] primarySelected variantID', variantID);
    }

    // Fallback 1: any ProductSelect-... hidden select (used on BEST template)
    if (!variantID) {
      var $fallbackSelected = $('[id^="ProductSelect-"] option:selected');
      console.log('[cdesk] fallbackSelected length', $fallbackSelected.length, $fallbackSelected.get());
      if ($fallbackSelected.length) {
        variantID = $.trim($fallbackSelected.val() || '');
        console.log('[cdesk] fallbackSelected variantID', variantID);
      }
    }

    // Fallback 2: first name="id" field inside a /cart/add form
    if (!variantID) {
      var $idInput = $('form[action="/cart/add"] [name="id"]:first');
      console.log('[cdesk] idInput length', $idInput.length, $idInput.get());
      if ($idInput.length) {
        variantID = $.trim($idInput.val() || '');
        console.log('[cdesk] idInput variantID', variantID);
      }
    }

    // Fallback 3: Subscribe-It config (for single-variant products)
    if (!variantID && window._SIConfig && _SIConfig.product && _SIConfig.product.selected_or_first_available_variant) {
      var siVariant = _SIConfig.product.selected_or_first_available_variant;
      variantID = $.trim(String(siVariant.id || ''));
      console.log('[cdesk] _SIConfig fallback variantID', variantID);
    }

    console.log('[cdesk] final resolved variantID for product-form__cart-submit', variantID);

    if(!variantID || variantID === 'undefined' || variantID === 'null'){
      currentThis.removeClass('untouchable');
      currentThis.text('Add To Cart');
      alert('Please select a variant before adding this item to your cart.');
      return;
    }

    Items.push({ "id": variantID, "quantity": 1 }); 
    ajaxAddToCart(currentThis,Items);

  });

  $(document).ready(function(){
    $('.best-product-carousel figure.grid__item.main_slide_video').click(function(event){
      event.stopPropagation();
      console.log('click');
      var thisVIdeo = $(this).find('video')
      if (thisVIdeo.get(0).paused) {
        thisVIdeo.trigger('play');
        thisVIdeo.next(".play").fadeOut(500);
      } else {
        thisVIdeo.trigger('pause');
        thisVIdeo.next(".play").fadeIn(500);
      }
    })
  })



  $(document).on('click', '.cart-popop .cart-deals a', function(){
    localStorage.setItem("upsell_product", "true"); 
  });
  var Upsell_text_btn = localStorage.getItem("upsell_product"); 
  //console.log('Upsell_text_btn:'+Upsell_text_btn);
  if(Upsell_text_btn == "true"){
    $('.best-product-button button').addClass('upsell_btn_text');  
    $('.best-product-button button span[data-add-to-cart-text]').text('Bundle Items & Update Cart');
    localStorage.removeItem ("upsell_product"); 
  }

  $('.displaylist').click(function(){
    $('.overlay').fadeIn();
    $('.location-switcher').fadeIn();
  });
 
  $('#CountryList li[data-value="GB"]').click(function(){
    $('.location-switcher').fadeOut();
    $('.overlay').fadeOut();    localStorage.setItem("isLocationalreadySet", "YES");

  });
  
  $('.close_store_btn').click(function(){
    $('.location-switcher').fadeOut();
    $('.overlay').fadeOut();
    localStorage.setItem("isLocationalreadySet" , "YES"); 
  });
  
  var isLocationalreadySet = localStorage.getItem("isLocationalreadySet"); 
  
  if(isLocationalreadySet == 'YES'){

  }else{
    $.getJSON("//ipapi.co/json/", (function(t) {
      var e = t.country_name; var currency = t.currency; console.log('currency :: '+currency);console.log('country_name :: '+e);
      
      if(isLocationalreadySet == null)
      {
        $('.location-switcher').fadeIn();
        $('.overlay').fadeIn();        
      } 
      else{} 
    }))
 
  }
  
  //   currency switcher
  $('#currency-list').change(function(){
    var  selectedVal = this.value;
    $(this).next().val(selectedVal);
    $(this).parents('.currencySelectors').submit();
  });

  //   	location switcher


  if(isLocationalreadySet == 'YES'){
    $('.close_store_btn').click(function(){
      $('.location-switcher').fadeOut();
      $('.overlay').fadeOut();
    });
  }else{
    $.getJSON("//ipapi.co/json/", (function(t) {
      var e = t.country_name; var currency = t.currency; console.log('currency :: '+currency);console.log('country_name :: '+e);

      console.log('isLocationalreadySet :: '+isLocationalreadySet);

      if(isLocationalreadySet == null)
      {
        $('.location-switcher').fadeIn();
        $('.overlay').fadeIn();
        $('#currency-list').next('#CurrencySelector').val(currency);

      } 
      else{

      }


    }))
    $('.close_store_btn').click(function(){
      localStorage.setItem("isLocationalreadySet", "YES");
      $('.location-switcher').fadeOut();
      $('.overlay').fadeOut();
      var currenCySelected = $('form#localization_form #CurrencySelector').val();
      $('#currency-list').val(currenCySelected).change(); 
    });


  }
  $('.location-swither-button .btn-switcher').click(function(){
    $(this).toggleClass('active');
    $(this).parent('.location-swither-button').find('.location-swither-dropdown').slideToggle();

  });
  $('.close_store_btn').click(function(){
    $('.location-swither-button .btn-switcher').removeClass('active');
    $('.location-swither-dropdown').fadeOut();
  });
  
  
  $('.location-swither-dropdown .customSelectBox ul li').click(function(){
    var thisVVall = $(this).attr('data-value');
    $('select#currency-list, #CurrencySelector').val(thisVVall);
    $('form#localization_form').submit();
  });
  
  
  $('.cdk__currency-list').change(function(){
    var thisVal = $(this).val();
    console.log('thisVal::'+thisVal);
    window.location.href = thisVal;
  })
 $('.first_li_click img').trigger('click');

    $('#ProductSelect-product-template').on('change', function () {


if (!$('#ProductJson-product-template').html()) { }else{
    var productJSON = JSON.parse(document.getElementById('ProductJson-product-template').innerHTML);
    var variantId = this.value;
    var variant = productJSON.variants.find((v) => v.id == variantId);

    // Price blocks
    var priceText = theme && theme.Currency && theme.moneyFormat
      ? theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      : (Shopify && Shopify.formatMoney ? Shopify.formatMoney(variant.price) : variant.price);
    var compareText = theme && theme.Currency && theme.moneyFormat
      ? theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)
      : (Shopify && Shopify.formatMoney ? Shopify.formatMoney(variant.compare_at_price) : variant.compare_at_price);

    if (variant.compare_at_price > variant.price) {
      $('[data-regular-price]').html(compareText)
      $('[data-sale-price]').html(priceText)
      $('[data-price]').addClass('sale')
    } else {
      $('[data-regular-price]').html(priceText)
      $('[data-price]').removeClass('sale')
    }

    // Update Save badge
    var saveAmt = (variant.compare_at_price > variant.price) ? (variant.compare_at_price - variant.price) : 0;
    if (saveAmt > 0) {
      var saveText = theme && theme.Currency && theme.moneyFormat
        ? theme.Currency.formatMoney(saveAmt, theme.moneyFormat)
        : (Shopify && Shopify.formatMoney ? Shopify.formatMoney(saveAmt) : saveAmt);
      $('.saleBadge_product .saleBadge').text('save ' + saveText);
      $('.saleBadge_product').show();
    } else {
      $('.saleBadge_product').hide();
    }

    // Update Add To Cart button to always show combined total
    $('.best-product-template .best-product-form .product-form__cart-submit').text('Add To Cart - ' + priceText);
  }
  });
  
});